<template>
  <div class="Exportblk4a">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn type="button" @click="exportexcelblk4a(tokenexport, exportthn,exportbln,exportps,paparnegeriexport)" color="blue white white--text">
            <span class="material-icons">file_download</span>
            {{ $t("muatturun") }} {{ $t("blk4a") }}
          </v-btn> -->
            <download-excel
              :data = "papardatablk4a"
              type="csv"
              name="blk4a.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("blk4a") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatablk4a"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";

import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  Name: "Exportblk4a",
  setup() {},
  props: ["papardatablk4a", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    databatch: "",
    headers: [
      //{ text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "P", value: "P"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      { text: "Kod Item", value: "KodItem"},
      { text: "RM HQ", value: "RMHQ"},
      { text: "RM NEG", value: "RMNEG"},
      { text: "Punca Pembelian", value: "PuncaPembelian"},
      { text: "Jenis Barang", value: "JenisBarang"},
      { text: "Sebenar Anggaran", value: "SebenarAnggaran"},
      { text: "Medium Bayaran", value: "MediumBayaran"},
      { text: "e-Dagang", value: "eDagang"},
      { text: "Kuantiti", value: "Kuantiti"},
      { text: "Unit", value: "Unit"},
      { text: "Keterangan", value: "Keterangan"},
      { text: "Catatan", value: "Catatan"},
      { text: "Bulan", value: "Bulan"},
      { text: "Tahun", value: "Tahun"},
     
      //{ text: "Wgt", value: "Wgt"},
       // { text: "RMHQBGST", value: "RMHQBGST"},
      
      
    ],
  }),
  methods: {
    async exportexcelblk4a(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/blk/exportblk4Aserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>